<template>
  <div>
    <v-btn
      v-if="params.data?.estadoAcademico"
      class="mb-2"
      x-small
      outlined
      :color="params.data?.estadoAcademico == estadosAcademicos['Modular'] ? 'error' : undefined"
      @click="handleClick"
      :disabled="obteniendoInscripcion"
      :loading="obteniendoInscripcion">
      {{ params.data?.estadoAcademico }}

      <v-icon small>mdi-information-outline</v-icon>
    </v-btn>

    <span v-else>-</span>

    <ModalHistorialesEstadosAcademicos
      ref="modalHistorialesEstadosAcademicosRef"
      :historialesEstadosAcademicos="inscripcion.historialesEstadosAcademicos" />
  </div>
</template>

<script>
import historialAcademicoMixin from '../mixins/historial-academico.mixin';

export default {
  name: 'BotonHistorialEstadosAcademicos',
  mixins: [historialAcademicoMixin],
  methods: {
    handleClick() {
      const inscripcionId = this.params.data?.id;

      if (inscripcionId) {
        this.obtenerInscripcionConHistorialEstadosAcademicos(inscripcionId);
      }
    },
  },
};
</script>